import { render, staticRenderFns } from "./Discipleship.vue?vue&type=template&id=182a2fc6&"
import script from "./Discipleship.vue?vue&type=script&lang=js&"
export * from "./Discipleship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports